import { PropsWithChildren, ReactElement, ReactNode, cloneElement, isValidElement } from "react";
import { Tooltip, TooltipProps } from "@mui/material";
import { PopoverButtonIconInfo } from "src/components-mui/base/wf-popover/popover-button-icon-info";
import { SimpleRichText } from "src/components-mui/common/rich-text/simple-rich-text";

interface IWfTooltipProps {
    content?: string;
    contentNode?: ReactNode;
    placement?: TooltipProps["placement"];
    children?: ReactElement;
    iconAs?: "button" | "span";
    ariaLabel?: string;
    slotProps?: TooltipProps["slotProps"];
    enterTouchDelay?: TooltipProps["enterTouchDelay"];
}

export const WfTooltip = ({
    content,
    contentNode,
    placement = "bottom",
    children,
    iconAs = "button",
    ariaLabel,
    slotProps,
    enterTouchDelay,
}: PropsWithChildren<IWfTooltipProps>) => {
    const trigger = children || <PopoverButtonIconInfo component={iconAs} ariaLabel={ariaLabel ?? content ?? ""} color="gray" />;

    const title = contentNode ?? (content && <SimpleRichText text={content} fontSize="sm" />);

    return (
        <Tooltip title={title} placement={placement} slotProps={slotProps} enterTouchDelay={enterTouchDelay} arrow>
            {isValidElement(trigger) ? cloneElement(trigger) : trigger}
        </Tooltip>
    );
};
